/* eslint-disable no-empty-pattern */

export const emails = {
    actions: {
        sendEmail({}, payload) {
            return this.$api.post('emails', payload)
        },

        async fetchMerchantPromoAttachments({}, { id, token }) {
            const res = await this.$api.get(
                'merchant_notification_promo_attachments/' + id,
                {
                    params: {
                        token
                    },
                    responseType: 'arraybuffer'
                }
            )

            const fileBlob = new Blob([res.data], {
                type: 'application/pdf'
            })
            const fileURL = URL.createObjectURL(fileBlob)

            const link = document.createElement('a')
            link.href = fileURL
            link.download = 'promo_attachments'
            document.body.appendChild(link)
            link.click()
            document.body.removeChild(link)
        }
    }
}
